/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevTerminalIcon32Regular = forwardRef('DevTerminalIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8.293 11.293a1 1 0 0 1 1.414 0l3.47 3.47a1.75 1.75 0 0 1 0 2.475l-3.47 3.47a1 1 0 0 1-1.414-1.415L11.586 16l-3.293-3.293a1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M17 19a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9.5A5.5 5.5 0 0 1 7.5 4h17A5.5 5.5 0 0 1 30 9.5v13a5.5 5.5 0 0 1-5.5 5.5h-17A5.5 5.5 0 0 1 2 22.5v-13ZM7.5 6A3.5 3.5 0 0 0 4 9.5v13A3.5 3.5 0 0 0 7.5 26h17a3.5 3.5 0 0 0 3.5-3.5v-13A3.5 3.5 0 0 0 24.5 6h-17Z" })));
});
